export default __webpack_public_path__ + "static/clipboard-expert-23708528438eda5a4de90875e095bd83.svg";